"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendResumeForm = exports.RequiredFields = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
// field components
const elements_1 = require("@src/components/elements");
const react_ga_1 = __importDefault(require("@src/helpers/react-ga"));
const gtm_1 = __importDefault(require("@src/helpers/gtm"));
const react_router_1 = require("react-router");
const Api = __importStar(require("@src/api"));
const socket_1 = require("@src/socket");
const types_1 = require("@src/types");
const useSSRFetch_1 = require("@src/hooks/useSSRFetch");
const account_context_1 = require("@src/context/account-context");
const queries_1 = require("@src/types/queries");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const feature_flags_1 = require("@src/helpers/feature-flags");
const auth_context_1 = require("@src/context/auth-context");
const use_query_parameters_1 = require("@src/helpers/use-query-parameters");
const ProfileResumeModal_1 = require("./ProfileResumeModal");
const formRules_1 = require("./formRules");
const fields_1 = require("./fields");
const PersonalInformation_1 = require("../../registration-candidate/PersonalInformation");
const Passwords_1 = require("../../registration-candidate/Passwords");
const SendResumeFields_style_1 = require("./fields/SendResumeFields.style");
var RequiredFields;
(function (RequiredFields) {
    RequiredFields["job"] = "job";
    RequiredFields["school"] = "school";
})(RequiredFields || (exports.RequiredFields = RequiredFields = {}));
const successfullySentNotification = (intl) => {
    antd_1.notification.success({
        message: intl.formatMessage({
            id: 'offer_detail.send_resume_form.thanks_for_your_offer_interest',
        }),
        placement: 'bottomRight',
    });
};
const successfullySentAndRegisteredNotification = (intl) => {
    antd_1.notification.success({
        message: intl.formatMessage({
            id: 'offer_detail.send_resume_form.thanks_for_your_offer_interest_and_registration',
        }),
        placement: 'bottomRight',
    });
};
const failNotification = (intl) => {
    antd_1.notification.error({
        message: intl.formatMessage({
            id: 'profile.resume.error',
        }),
        description: intl.formatMessage({
            id: 'profile.resume.something_went_wrong',
        }),
        placement: 'bottomRight',
    });
};
const SendResumeForm = ({ offer, sendResumeButtonRef }) => {
    const intl = (0, react_intl_1.useIntl)();
    const rules = react_1.default.useMemo(() => (0, formRules_1.sendResumeFormRules)(intl), [formRules_1.sendResumeFormRules]);
    const [form] = antd_1.Form.useForm();
    const history = (0, react_router_1.useHistory)();
    const [resumeFileList, setResumeFileList] = react_1.default.useState([]);
    const [motivationalLetterFileList, setMotivationalLetterFileList] = react_1.default.useState([]);
    const account = (0, account_context_1.useAccount)();
    const isUserLoggedIn = Boolean(account);
    const { data: myResumes } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getMyResumes, Api.Account.getMyResumes, {
        enabled: isUserLoggedIn,
    });
    const { createQueryParams } = (0, use_query_parameters_1.useQueryParameters)();
    const [hasResumesAndWantsToUpload, setHasResumesAndWantsToUpload] = react_1.default.useState(false);
    const [sendProfileAsResume, setSendProfileAsResume] = react_1.default.useState(offer.resumeRequired === 1 && isUserLoggedIn);
    const [hasAlreadySentApplication, setHasAlreadySentApplication] = react_1.default.useState(false);
    const [wantSendApplicationAgain, setWantSendApplicationAgain] = react_1.default.useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = react_1.default.useState(false);
    const [profileEmptyFields, setProfileEmptyFields] = react_1.default.useState([]);
    const [isLoading, setIsLoading] = react_1.default.useState(false);
    const [isInitialized, setIsInitialized] = react_1.default.useState(false);
    const hasSetInitialProfileAsResume = react_1.default.useRef(false);
    const hasSetInitialFormValues = react_1.default.useRef(false);
    const SSRFetchClient = (0, useSSRFetch_1.useSSRFetchClient)();
    const { checkAuthentication } = (0, auth_context_1.useAuthContextValue)();
    react_1.default.useEffect(() => {
        if (myResumes === null || myResumes === void 0 ? void 0 : myResumes.length) {
            const defaultResume = myResumes.find(r => r.default);
            form.setFieldsValue({ savedResumes: (defaultResume === null || defaultResume === void 0 ? void 0 : defaultResume.id) || 0 });
        }
    }, [myResumes]);
    function checkRequiredFields(allProfileEmptyFields) {
        const isJobEmpty = allProfileEmptyFields.includes(RequiredFields.job);
        const isSchoolEmpty = allProfileEmptyFields.includes(RequiredFields.school);
        return isJobEmpty && isSchoolEmpty;
    }
    const hasEmptyRequiredFields = react_1.default.useMemo(() => {
        return checkRequiredFields(profileEmptyFields);
    }, [profileEmptyFields]);
    async function uploadGeneratedResume(file) {
        return Api.Media.uploadDocument(file, 'user-document');
    }
    const onFormSubmit = async (sendResumeForm) => {
        try {
            setIsLoading(true);
            let sendResumeResponse;
            if (sendProfileAsResume) {
                let applicantProfilePDF;
                let resumeUrl = null;
                if ((offer.sendApplicationToContactPerson && (0, feature_flags_1.isFeatureContactEmailEnabled)(offer.company_id)) ||
                    offer.graftonId) {
                    const applicantProfile = await Api.Profile.getMyProfile();
                    const { pdf } = await Promise.resolve().then(() => __importStar(require('@react-pdf/renderer')));
                    const { ApplicantProfilePDF } = await Promise.resolve().then(() => __importStar(require('@src/components/pages/profile/modules/resume/PDF/ApplicantProfilePDF')));
                    applicantProfilePDF = await pdf((0, jsx_runtime_1.jsx)(ApplicantProfilePDF, { applicantProfile: applicantProfile })).toBlob();
                    if (offer.graftonId) {
                        const { url } = await uploadGeneratedResume(new File([applicantProfilePDF], `${account === null || account === void 0 ? void 0 : account.firstName}_${account === null || account === void 0 ? void 0 : account.lastName}-${new Date().getTime()}.pdf`));
                        resumeUrl = url;
                    }
                }
                sendResumeResponse = await Api.Profile.sendProfileAsResume({
                    offerId: offer.id,
                    profileUuid: account === null || account === void 0 ? void 0 : account.uuid,
                    ...sendResumeForm,
                }, applicantProfilePDF, resumeUrl);
            }
            else {
                sendResumeResponse = await Api.Profile.sendResume({
                    offerId: offer.id,
                    ...sendResumeForm,
                });
            }
            const { account: createdAccount } = sendResumeResponse.data;
            const { savedOffer } = await Api.SavedOffer.getSavedOfferById(offer.id);
            if (savedOffer) {
                react_ga_1.default.event({
                    category: 'Applicant',
                    action: 'Application to saved offer',
                    label: 'Applicant sent application for saved offer',
                });
                gtm_1.default.dataLayer({
                    event: 'applicant_applied_to_saved_offer',
                    category: 'applicant',
                });
                await Api.SavedOffer.deleteSavedOffer(offer.id);
            }
            // @ts-ignore
            // eslint-disable-next-line no-undef
            fbq('track', 'SubmitApplication');
            gtm_1.default.dataLayer({
                event: 'applicant_response_submitted',
                category: 'applicant',
            });
            socket_1.socket.emit(types_1.SocketEvents.ACCOUNT_AUTHENTICATED, createdAccount);
            SSRFetchClient.invalidateSSRContext(useSSRFetch_1.SSRFetchConfig.account.key);
            if (sendResumeResponse.status === 200) {
                setIsLoading(false);
                history.pushLocalized('/ucet');
                successfullySentNotification(intl);
            }
            else if (sendResumeResponse.status === 201) {
                setIsLoading(false);
                history.pushLocalized('/ucet');
                successfullySentAndRegisteredNotification(intl);
            }
            else {
                failNotification(intl);
            }
        }
        catch (err) {
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
            // eslint-disable-next-line no-console
            console.error(err);
        }
        finally {
            setIsLoading(false);
        }
    };
    const loginWithButton = async () => {
        try {
            await checkAuthentication();
        }
        catch (err) {
            if (err !== types_1.AccountErrorCode.login_canceled) {
                antd_1.notification.error({
                    message: intl.formatMessage({
                        id: 'general.error',
                    }),
                    description: intl.formatMessage({
                        id: 'general.something_went_wrong',
                    }),
                });
                console.error(err);
            }
        }
    };
    react_1.default.useEffect(() => {
        if (account && !hasSetInitialFormValues.current) {
            hasSetInitialFormValues.current = true;
            form.setFieldsValue({
                first_name: account.firstName,
                last_name: account.lastName,
                email: account.email,
            });
        }
    }, [account]);
    const changeSendProfileAsResume = react_1.default.useCallback((newSendProfileAsResume) => {
        setSendProfileAsResume(newSendProfileAsResume);
        form.setFieldsValue({ sendProfileResume: newSendProfileAsResume });
    }, [form]);
    react_1.default.useEffect(() => {
        if (account && !hasSetInitialProfileAsResume.current) {
            hasSetInitialProfileAsResume.current = true;
            changeSendProfileAsResume(offer.resumeRequired === 1 && isUserLoggedIn);
        }
    }, [account, changeSendProfileAsResume, offer.resumeRequired, isUserLoggedIn]);
    async function init() {
        try {
            const offerApplication = await Api.OfferApplication.getOfferApplicationByOfferId(offer.id);
            if (offerApplication) {
                setHasAlreadySentApplication(true);
            }
        }
        catch (err) {
            // do nothing
        }
    }
    react_1.default.useEffect(() => {
        init();
        setIsInitialized(true);
    }, []);
    const onSubmitClick = async () => {
        form.validateFields()
            .then(async () => {
            setIsLoading(true);
            if (account === null || account === void 0 ? void 0 : account.email) {
                const profileEmptyFieldsResponse = await Api.Profile.getEmptyResumeFields();
                setProfileEmptyFields(profileEmptyFieldsResponse);
                const hasActualEmptyRequiredFields = checkRequiredFields(profileEmptyFieldsResponse);
                if (hasActualEmptyRequiredFields) {
                    setShowConfirmationModal(true);
                }
                else {
                    form.submit();
                }
            }
            setIsLoading(false);
        })
            .catch(() => { });
    };
    const isCTARedirect = Boolean(offer.redirectUrl);
    const redirectWithUTMParams = react_1.default.useMemo(() => {
        var _a;
        const qp = createQueryParams({
            utm_source: 'pracuj_sk',
            utm_medium: 'job_post',
            utm_campaign: 'pracuj_sk',
        });
        return ((_a = offer.redirectUrl) === null || _a === void 0 ? void 0 : _a.includes('?')) ? `${offer.redirectUrl}&${qp}` : `${offer.redirectUrl}?${qp}`;
    }, [isCTARedirect]);
    if (!isInitialized) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("div", { id: "send-resume", children: [(0, jsx_runtime_1.jsx)(elements_1.Panel, { children: (0, jsx_runtime_1.jsxs)("div", { children: [isCTARedirect && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-col flex-center", children: [(0, jsx_runtime_1.jsx)("h2", { className: "m-b-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.cta_redirect.notice" }) }), (0, jsx_runtime_1.jsx)("a", { href: redirectWithUTMParams, target: "_blank", rel: "noreferrer noopenner", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-t-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.details.cta_redirect.cta" }) }) })] })), !isCTARedirect && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isUserLoggedIn && (!hasAlreadySentApplication || wantSendApplicationAgain) && ((0, jsx_runtime_1.jsx)("h1", { className: "form__title", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: offer.resumeRequired
                                            ? 'offer_detail.send_resume_form.send_resume'
                                            : 'offer_detail.send_resume_form.send_application' }) })), !isUserLoggedIn && ((0, jsx_runtime_1.jsx)("h1", { className: "form__title", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: offer.resumeRequired
                                            ? 'offer_detail.send_resume_form.send_resume_and_create_account'
                                            : 'offer_detail.send_resume_form.send_application_and_create_account' }) })), hasAlreadySentApplication && !wantSendApplicationAgain && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-col flex-center", children: [(0, jsx_runtime_1.jsx)("h1", { className: "m-b-l", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "general.notice" }) }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.send_twice" }), (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "m-t-l", onClick: () => setWantSendApplicationAgain(true), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.wanna_send_twice" }) })] })), !isUserLoggedIn && ((0, jsx_runtime_1.jsxs)("div", { className: "p-none m-b-s font-bold", children: [(0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.already_registered" }), (0, jsx_runtime_1.jsx)(elements_1.Button, { className: "text-underline font-bold", size: "small", type: "text", onClick: () => loginWithButton(), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.already_registered_button" }) })] })), (!hasAlreadySentApplication || wantSendApplicationAgain) && ((0, jsx_runtime_1.jsxs)(antd_1.Form, { form: form, onFinish: onFormSubmit, className: "form form--login", name: "sendResumeForm", layout: "vertical", children: [!isUserLoggedIn && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PersonalInformation_1.PersonalInformation, { rules: rules, intl: intl }), (0, jsx_runtime_1.jsx)(Passwords_1.Passwords, { rules: rules, intl: intl })] })), (0, jsx_runtime_1.jsx)(fields_1.SendResumeFields, { rules: rules, offer: offer, myResumes: myResumes || [], isUserLoggedIn: isUserLoggedIn, hasResumesAndWantsToUpload: hasResumesAndWantsToUpload, setHasResumesAndWantsToUpload: setHasResumesAndWantsToUpload, sendProfileAsResume: sendProfileAsResume, setSendProfileAsResume: changeSendProfileAsResume, resumeFileList: resumeFileList, motivationalLetterFileList: motivationalLetterFileList, setMotivationalLetterFileList: setMotivationalLetterFileList, setResumeFileList: setResumeFileList }), !sendProfileAsResume && ((0, jsx_runtime_1.jsx)("div", { ref: sendResumeButtonRef, className: "form__submit", "data-cy": "form-submit", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { htmlType: "submit", color: "brand", loading: isLoading, children: intl.formatMessage({
                                                    id: 'offer_detail.send_resume_form.send',
                                                }) }) })), sendProfileAsResume && isUserLoggedIn && ((0, jsx_runtime_1.jsx)(SendResumeFields_style_1.SubmitButtonWrapper, { ref: sendResumeButtonRef, "data-cy": "form-submit", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: onSubmitClick, color: "brand", loading: isLoading, children: (0, jsx_runtime_1.jsx)("span", { className: "m-l-xs", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.send" }) }) }) })), (0, jsx_runtime_1.jsxs)(SendResumeFields_style_1.RequiredWrapper, { children: [(0, jsx_runtime_1.jsx)(SendResumeFields_style_1.RedText, { children: "*" }), (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "offer_detail.send_resume_form.required_fields" })] })] }))] }))] }) }), (0, jsx_runtime_1.jsx)(ProfileResumeModal_1.ConfirmProfileAsResumeModal, { visible: showConfirmationModal, setShowConfirmationModal: setShowConfirmationModal, profileEmptyFields: profileEmptyFields, setProfileEmptyFields: setProfileEmptyFields, hasEmptyRequiredFields: hasEmptyRequiredFields, okButtonProps: { form: 'sendResumeForm', key: 'submit', htmlType: 'submit' } })] }));
};
exports.SendResumeForm = SendResumeForm;
